import { useEffect, useRef, useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { IMessagewarnlistDetail, IMessagewarnlistSearchFields, messagewarnlistService } from "./messagewarnlistService";
import useGlobalModel, { transPgToPagination } from "@/model/globalModel";
import { ISearchPage } from "@/types/AppTypes";
import { message, Modal } from "antd";

export const useMessagewarnlistModel = createModel(function () {
    const { searchMsgUnreadNum } = useGlobalModel()
    //列表数据源
    const [dataSource, setDataSource] = useState<IMessagewarnlistDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IMessagewarnlistSearchFields>({});
    const orders = useRef<{ column: string; asc: boolean }[]>([])
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<IMessagewarnlistDetail[]>([]);
    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg)
    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])
    //列表查询
    const loadData = async (page: ISearchPage = pgCfgRef.current, searchValue: IMessagewarnlistSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? DEFAULT_FIRST_PAGE_NUM,
            orders: orders.current,
        }
        let { retData } = await messagewarnlistService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IMessagewarnlistSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    const [columnsSetVisible, setColumnsSetVisible] = useState<boolean>(false)


    const handleRead = (record) => {
        Modal.confirm({
            title: '确定',
            centered: true,
            closable: true,
            content: "确定要标为已读？",
            onOk() {
                messagewarnlistService.read(record.id).then((res) => {
                    if (res.retData) {
                        message.success('编辑成功！')
                    } else {
                        message.error('编辑失败')
                    }
                    loadData()
                    searchMsgUnreadNum()
                })
            },
        })
    }


    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        columnsSetVisible,
        orders,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        setColumnsSetVisible,
        handleRead
    }
});